import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'

import { QUERY_KEYS } from '../../../lib/queryKeys'
import { getPackageReqs } from '../packageReqService'

export const usePackageReqs = ({ warehouse, userId, userEmail, onlyPending = true } = {}) => {
  const { loggedUser } = useSelector(state => state.user)
  const userWarehouse = loggedUser.permissions['Admin'] ? '' : loggedUser.UserAttributes['custom:warehouse']
  const warehouseToUse = warehouse ?? userWarehouse

  return useQuery({
    queryKey: [QUERY_KEYS.PACKAGE_REQUESTS, warehouseToUse, onlyPending],
    queryFn: () => getPackageReqs({ warehouse: warehouseToUse, onlyPending }),
    select:
      userId || userEmail
        ? data => {
            return Object.keys(data).reduce((acc, key) => {
              acc[key] = data[key].filter(req => req.customerId === userId || req.costumerEmail === userEmail)
              return acc
            }, {})
          }
        : undefined,
  })
}
